// extracted by mini-css-extract-plugin
export default {"calendarPage":"Calendar_calendarPage__FULk1","assignments":"Calendar_assignments__eCCA1","planner":"Calendar_planner__mT8cq"};